import React from "react";

const TextOverlay = ({ text, children }) => {
  return (
    <div className="text-overlay-container">
      {children}
      {text && <div className="text-overlay">{text}</div>}
    </div>
  );
};

export default TextOverlay;
